// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1NQoD","select":"Header_select__341WH","clinic":"Header_clinic__m3crq"};